import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'end',
      gap: '20px',
      marginBottom: '-8px'
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
